import { icons } from '@ublend-npm/aulaui-next';
import React, { useRef, useState } from 'react';
import H5AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useAnalytics } from '../../lib/useAnalytics';
import {
  AudioPlayerButton,
  AudioPlayerButtonIcon,
  AudioPlayerWrapper,
} from './AudioPlayer.styled';

export type AudioPlayerProps = {
  src: string;
  onError?: () => void;
};

export const AudioPlayer = (props: AudioPlayerProps) => {
  const track = useAnalytics();
  const playerRef = useRef<H5AudioPlayer>(null);
  const [playing, setPlaying] = useState(false);

  const handleToggle = async (play: boolean) => {
    if (play) {
      track('START_AUDIO_PLAYER');
      await playerRef?.current?.audio.current?.play();
    } else {
      track('STOP_AUDIO_PLAYER');
      playerRef?.current?.audio.current?.pause();
    }
    setPlaying(play);
  };

  const { src, onError = () => {} } = props;
  return (
    <AudioPlayerWrapper data-testid="audio-player">
      <AudioPlayerButton
        tabIndex={0}
        aria-label={playing ? 'Pause' : 'Play'}
        onClick={async () => await handleToggle(!playing)}
      >
        <AudioPlayerButtonIcon>
          {playing ? <icons.Pause /> : <icons.Play />}
        </AudioPlayerButtonIcon>
      </AudioPlayerButton>
      <H5AudioPlayer
        ref={playerRef}
        autoPlay={false}
        src={src}
        layout="horizontal"
        customControlsSection={[]}
        customAdditionalControls={[]}
        showJumpControls={false}
        onError={onError}
      />
    </AudioPlayerWrapper>
  );
};
